<script>
import colors from '@/modules/cells/colors'
import { $axios } from '@/modules/http/axios'
import Popper from 'vue3-popper'
import Swal from 'sweetalert2'
import emitter from '@/modules/events/emitter'

export default {
  name: 'ColorsEditor',
  components: { Popper },
  props: ['givenTask', 'givenTaskRoute'],
  data () {
    return {
      colors: colors,
      taskRoute: this.givenTaskRoute
    }
  },
  methods: {
    async updateProperty (colorKey, color) {
      this.taskRoute[colorKey] = color

      try {
        await $axios.put(`${this.taskRoute.id}/TaskRoute`, this.taskRoute)
        emitter.emit('taskChanged', { taskId: this.taskId })
      } catch (e) {
        await Swal.fire(
          'Nie udało się zaktuzlizować koloru referencji',
          `System nie był w stanie wykonać żądanej operacji, <br> <span class="fw-bolder">Kod błędu: ${e.response.status}</span>`,
          'error'
        )
      }
    }
  }
}
</script>

<template>
  <Popper placement="right" v-if="!givenTask.archived">
    <span role="button" :style="`color: ${taskRoute.altTextColor};`" class="px-2">
      <i class="fa-solid fa-pen-to-square"></i>
    </span>
    <template #content>
      <div class="text-sm mt-2 user-select-none">
        Kolor czcionki
        <div>
          <span
            @click="updateProperty('altTextColor', color)"
            v-for="color in colors"
            :key="color"
            role="button"
            class="px-1 mx-1 border border-1"
            :style="`background-color: ${color}; color: ${color};`"
          ></span>
        </div>
      </div>
      <div class="text-sm mt-2 user-select-none">
        Kolor komórki
        <div class="mt-1">
          <span
            @click="updateProperty('altBackgroundColor', color)"
            v-for="color in colors"
            :key="color"
            role="button"
            class="px-1 mx-1 border border-1"
            :style="`background-color: ${color}; color: ${color};`"
          ></span>
        </div>
      </div>
    </template>
  </Popper>
</template>
